/**
 * Endereços em português que o menu da área de membros usa (cadastrado pelo
 * admin) e a página de verdade de cada um. Sem isto, "/cursos", "/perfil" e
 * "/certificados" caíam na rota curinga e abriam o Início: todo item do menu
 * levava para a mesma tela.
 */
export const ROTAS_EM_PORTUGUES: Record<string, string> = {
  '/inicio': '/home',
  '/cursos': '/courses',
  '/certificados': '/certificates',
  '/perfil': '/profile',
  '/comunidade': '/community',
  '/trilhas-de-carreira': '/trilhas',
  '/eventos': '/events',
  '/agenda': '/events',
};

/** Rota real de um endereço do menu (para acender o item certo). */
export function rotaReal(url?: string | null) {
  if (!url) return '';
  if (url === '/dashboard') return '/home';
  const aulas = url.match(/^\/cursos\/([^/?#]+)\/aulas\/?([?#].*)?$/);
  if (aulas) return `/courses/${aulas[1]}/trail${aulas[2] ?? ''}`;
  return ROTAS_EM_PORTUGUES[url] ?? url;
}
